export enum BriefingRecurrenceFrequencyApiEnum {
    daily = 'DAILY',
    monthly = 'MONTHLY',
    quarterly = 'QUARTERLY'
}
